import { UserDatenRubrikMenge } from "./user-daten-rubrik-menge.model";

export class UserDatenEingabe {
    userDatenRubrikMenge: UserDatenRubrikMenge[] = [];
    bezeichnung: string
    idRegion: number;
}
